export default "__VITE_ASSET__BScRFxck__"